import { render, staticRenderFns } from "./DispatchOrderPool.vue?vue&type=template&id=265d34a2&scoped=true&"
import script from "./DispatchOrderPool.vue?vue&type=script&lang=js&"
export * from "./DispatchOrderPool.vue?vue&type=script&lang=js&"
import style0 from "./DispatchOrderPool.vue?vue&type=style&index=0&id=265d34a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265d34a2",
  null
  
)

export default component.exports